module.exports = __webpack_public_path__ + "static/media/pinDarkBlue.9476842e.svg";